import 'css-chunksrc/client/scenes/projectDetailsConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_pdqw3_1",
  "listRoot": "_listRoot_pdqw3_14",
  "list": "_list_pdqw3_14",
  "item": "_item_pdqw3_30",
  "icon": "_icon_pdqw3_43",
  "timeSheetIcon": "_timeSheetIcon_pdqw3_51",
  "name": "_name_pdqw3_56"
};